import { Injectable } from '@angular/core';
import { UrlService } from '../url/url.service';
import { HttpService, ResponseType } from '../http/http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private _urlService: UrlService, private _httpService: HttpService) {}

  save(Token: string, urlSource: string): Observable<any> {
    const url = this._urlService.getUrl(urlSource, {});
    return this._httpService.post(url, { Token }, ResponseType.JSON);
  }

  get(id: string, urlSource: string): Observable<any> {
    const url = this._urlService.getUrl(urlSource, { id });
    return this._httpService.get(url, {});
  }
}
